import React, { useState, useRef, useEffect, useMemo } from "react";
import { motion } from "framer-motion";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import IRMenu from "../IRMenu";
import Sidebar from "../../../../myfin_v2/elements/Sidebar";
import { Button } from "../../../../myfin_v2/elements/Button";
import commoncss from "../../../../myfin_v2/css/common.module.css";
import buttoncss from "../../../../myfin_v2/css/button.module.css";
import investmentRegisterCss from "../../../../myfin_v2/css/investmentRegister.module.css";
import { ReactComponent as LeftArrowIcon } from "../../../../myfin_v2/assets/icons/left_arrow.svg";
import { ReactComponent as DotIcon }        from "../../../../myfin_v2/assets/icons/dot.svg";
import { ReactComponent as CalenderIcon }   from "../../../../myfin_v2/assets/icons/calender.svg";
import { ReactComponent as DownArrow }      from "../../../../myfin_v2/assets/icons/down-arrow.svg";
import ArrowCircle from "../../../../myfin_v2/assets/icons/ArrowCircle.png";
import WarningIcon from  "../../../../myfin_v2/assets/icons/warningIcon.png";
import rupeeIcon from "../../../../myfin_v2/assets/icons/Rupee.png";
import { ReactComponent as PlusIcon } from "../../../../myfin_v2/assets/icons/plusBlack.svg";
import { ReactComponent as RemoveIcon } from "../../../../myfin_v2/assets/icons/removeLoansIcons.svg";
import { createInvestmentTransaction, GetProjectsBasedOnUserId, getLinkedCompanies, GetAllCompanyData, getInvestmentRegisterForms, getAllConsolApi } from "../../../../WorkSpace/Components/ApiServices/apiHandler";
import { useHistory, useLocation } from "react-router-dom";
import CommonDatePicker from "../../../../myfin_v2/elements/CommonDatePicker";
import SuccessPopup from "../../../../myfin_v2/elements/SuccessPopup";
import ErrorPopup from "../../../../myfin_v2/elements/ErrorPopup";
import ConsolEntryConfigModal from "../components/InvestmentForms/ConsolEntryConfigModal";

 const formatIndianNumber = (val) => {
    if (val == null) return "";
    const num = Number(val);
    if (isNaN(num)) return String(val);

    if (num < 0) {
      return "(" + (-1 * num).toLocaleString("en-IN") + ")";
    }
    return num.toLocaleString("en-IN");
  };
const NATURE_OPTIONS = [
  { value: "Purchase of Shares",                label: "Purchase of Shares" },
  { value: "Sale of Shares to Third Party",     label: "Sale of Shares to Third Party" },
  // { value: "Buyback by Investee from Investor", label: "Buyback by Investee from Investor" },
  // { value: "Subscription to Rights Issue",      label: "Subscription to Rights Issue" },
  // { value: "Stock Split by Investee",           label: "Stock Split by Investee" },
  // { value: "Bonus Issue by Investee",           label: "Bonus Issue by Investee" },
];

const CLASS_OF_SHARE_OPTIONS = [
  { value: "Equity",          label: "Equity" },
  { value: "Preference",      label: "Preference" },
  { value: "Right Issue",     label: "Right Issue" },
  { value: "Lease Liability", label: "Lease Liability" },
];

const COST_BASIS_OPTIONS = [
  { value: "FIFO",         label: "FIFO" },
  { value: "LIFO",         label: "LIFO" },
  { value: "Average Cost", label: "Average Cost" },
];

const RELATIONSHIP_OPTIONS = [
  { value: "Investment", label: "Investment" },
  { value: "Subsidiary", label: "Subsidiary" },
  { value: "Associate",  label: "Associate" },
  { value: "Joint Venture", label: "Joint Venture" },
];


const CustomDropdown = ({ label, options, value, onChange, placeholder, fullWidth }) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [activeIndex, setActiveIndex] = useState(-1);
  const ref = useRef(null);

  const selected = (options || []).find((o) => o.value === value || o.label === value);

  useEffect(() => {
      setActiveIndex(-1);
  }, [search, open]);

  const handleKeyDown = (e) => {
      if (!open && (e.key === "ArrowDown" || e.key === "ArrowUp")) {
          setOpen(true);
          return;
      }
      if (e.key === "ArrowDown") {
          e.preventDefault();
          setActiveIndex(prev => (prev < filteredOptions.length - 1 ? prev + 1 : prev));
      } else if (e.key === "ArrowUp") {
          e.preventDefault();
          setActiveIndex(prev => (prev > 0 ? prev - 1 : prev));
      } else if (e.key === "Enter") {
          e.preventDefault();
          if (open && activeIndex >= 0 && activeIndex < filteredOptions.length) {
              const opt = filteredOptions[activeIndex];
              onChange(opt.value);
              setSearch(opt.label);
              setOpen(false);
          }
      }
  };

  useEffect(() => {
      if (selected) {
          setSearch(selected.label);
      } else if (value) {
          setSearch(value);
      } else {
          setSearch("");
      }
  }, [value, options, selected]);

  useEffect(() => {
    const close = (e) => { 
        if (ref.current && !ref.current.contains(e.target)) {
            setOpen(false); 
            if (selected) {
                setSearch(selected.label);
            } else if (value) {
                setSearch(value);
            }
        }
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, [selected, value]);

  const list = options || [];
  let filteredOptions = list;
  if (!(selected && search === selected.label) && search && search.trim()) {
    filteredOptions = list.filter((opt) =>
      String(opt.label || "").toLowerCase().includes(search.toLowerCase())
    );
  }

  const handleInputChange = (e) => {
      const val = e.target.value;
      setSearch(val);
      setOpen(true);
      const matched = (options || []).find(
          (o) => o.label.toLowerCase() === val.toLowerCase() || String(o.value).toLowerCase() === val.toLowerCase()
      );
      if (matched) {
          onChange(matched.value);
      } else {
          onChange(val);
      }
  };

  return (
    <div style={{ flex: fullWidth ? undefined : 1, width: fullWidth ? "100%" : undefined }}>
      {label && <label className={investmentRegisterCss.label} style={{ display: "block", marginBottom: 6 }}>{label}</label>}
      <div ref={ref} style={{ position: "relative" }}>
        <div className={investmentRegisterCss.dropdownField} onClick={() => setOpen((p) => !p)} style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
          <input
              className={investmentRegisterCss.input}
              style={{ 
                  border: "none", 
                  padding: 0, 
                  height: "auto", 
                  flex: 1, 
                  color: selected && search === selected.label ? "#205a46" : "#111", 
                  fontSize: "14px",
                  backgroundColor: "transparent",
                  outline: "none"
              }}
              value={search}
              placeholder={placeholder || "Select"}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
          />
          <motion.span animate={{ rotate: open ? 180 : 0 }} transition={{ duration: 0.2 }} className={investmentRegisterCss.chevron} onClick={(e) => { e.stopPropagation(); setOpen(!open); }}>
            <DownArrow width={18} height={18} />
          </motion.span>
        </div>
        {open && (
          <div className={investmentRegisterCss.dropdownMenuScrollable} style={{ zIndex: 999 }}>
            {filteredOptions.length > 0 ? filteredOptions.map((opt, i) => (
              <div
                key={i}
                className={`${investmentRegisterCss.dropdownItem} ${opt.value === value || activeIndex === i ? investmentRegisterCss.dropdownItemActive : ""}`}
                style={activeIndex === i ? { backgroundColor: "#f4faf5", color: "#2d8861" } : {}}
                onClick={() => { 
                    onChange(opt.value); 
                    setSearch(opt.label);
                    setOpen(false); 
                }}
              >
                {opt.label}
              </div>
            )) : (
              <div className={investmentRegisterCss.dropdownItem} style={{ color: "#b3c0bd" }}>No options found</div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

const TextInput = ({ label, placeholder, value, onChange, readOnly }) => (
  <div style={{ flex: 1 }}>
    {label && <label className={investmentRegisterCss.label} style={{ display: "block", marginBottom: 6 }}>{label}</label>}
    <input
      className={investmentRegisterCss.input}
      placeholder={placeholder}
      value={value || ""}
      onChange={(e) => onChange && onChange(e.target.value)}
      readOnly={readOnly}
    />
  </div>
);

const AmountInput = ({ label, placeholder, value, onChange }) => (
  <div style={{ flex: 1 }}>
    {label && <label className={investmentRegisterCss.label} style={{ display: "block", marginBottom: 6 }}>{label}</label>}
    <div className={investmentRegisterCss.inputWrapper}>
      <input
        className={investmentRegisterCss.input}
        placeholder={placeholder || "Enter Amount"}
        value={value || ""}
        onChange={(e) => onChange && onChange(e.target.value)}
        style={{ paddingRight: "36px" }}
      />
      <span className={investmentRegisterCss.iconRight}>
        <img src={rupeeIcon} alt="₹" className={investmentRegisterCss.rupeeIcon} />
      </span>
    </div>
  </div>
);
export const DateInput = ({ label, value, onChange, placement = "bottom" }) => {
    const validDate = value ? (typeof value === 'string' && value.match(/^\d{2}-\d{2}-\d{4}$/) ? new Date(value.split('-').reverse().join('-')) : new Date(value)) : null;
    return (
        <div style={{ flex: 1 }}>
            {label && <label className={investmentRegisterCss.label} style={{ display: "block", marginBottom: 6 }}>{label}</label>}
            <CommonDatePicker
                value={validDate}
                onChange={(newVal) => onChange && onChange(newVal ? dayjs(newVal).format("DD-MM-YYYY") : "")}
                containerClass={investmentRegisterCss.inputWrapper}
                inputClass={investmentRegisterCss.input}
                iconStyle={{ position: "absolute", right: "12px", top: "50%", transform: "translateY(-50%)" }}
                placement={placement}
            />
        </div>
    );
};



const Section = ({ children }) => (
  <div style={{
    background: "#fff", border: "1px solid #EAEEED", borderRadius: "14px",
    padding: "24px 28px", marginBottom: "16px",
    display: "flex", flexDirection: "column", gap: "20px",
  }}>
    {children}
  </div>
);

const Row = ({ children }) => (
  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "16px", alignItems: "start" }}>
    {children}
  </div>
);

const Row2 = ({ children }) => (
  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px", alignItems: "start" }}>
    {children}
  </div>
);

const getStatusStyle = (relationship) => {
  switch (relationship) {
    case "Investment":
      return {
        background: "#E8FEFF",
        color: "#42778B",
        border: "1px solid #CAE6E6",
      };

    case "Associate":
    case "Associate Company":
      return {
        background: "#FDF5E9",
        color: "#A7683E",
        border: "1px solid #EDE3D8",
      };

    case "Joint Venture":
      return {
        background: "#F6FDE7",
        color: "#778F41",
        border: "1px solid #DAEAAE",
      };

    case "Subsidiary":
      return {
        background: "#F0EBFD",
        color: "#564AC5",
        border: "1px solid #D4D1E3",
      };

    default:
      return {};
  }
};

const HoldingStatus = ({
  previousShares = 0,
  currentShares = 0,
  previousOwnership = 0,
  currentOwnership = 0,
  ownershipDifference = 0,
  sharesDifference = 0,
  relationship,
}) => {
  const numPrevShares = Number(previousShares) || 0;
  const numCurrShares = Number(currentShares) || 0;
  const numPrevOwnership = Number(previousOwnership) || 0;
  const numCurrOwnership = Number(currentOwnership) || 0;
  const numOwnerDiff = Number(ownershipDifference) || 0;
  const numSharesDiff = Number(sharesDifference) || 0;

  return (
  <div style={{
    background: "#fff", border: "1px solid #EAEEED",
    borderRadius: "14px", padding: "24px 28px", marginBottom: "16px",
  }}>
    <div
    style={{
      marginLeft: "-28px",
      marginRight: "-28px",
      paddingLeft: "28px",
      paddingRight: "28px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: "20px",
      paddingBottom: "16px",
      borderBottom: "1px solid #EAEEED",
    }}
  >
      <span style={{ fontSize: "18px", fontWeight: "500", color: "#111" }}>Holding &amp; status</span>
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <span style={{ fontSize: "13px", color: "#66827A" }}>Current Status</span>
        <span style={{
          ...getStatusStyle(relationship),
          padding: "4px 14px",
          borderRadius: "20px",
          fontSize: "13px",
          fontWeight: "700",
          letterSpacing: "0.04em",
        }}>
          {relationship ? relationship.toUpperCase() : "—"}
        </span>
      </div>
    </div>

    <div style={{
      padding: "18px 20px", marginBottom: "20px",
      display: "flex", alignItems: "flex-start", gap: "14px",
    }}>
      <img src={WarningIcon} alt="icon"  width="35" height="35"/>
      <div>
        <div style={{ fontSize: "20px", fontWeight: "300", color: "#111", marginBottom: "4px" }}>
          Status Changed! You're now a {relationship || "—"}
        </div>
        <div style={{ fontSize: "15px", color: "#66827A" }}>
          Ownership changed to {numCurrOwnership.toFixed(2)}%
        </div>
      </div>
    </div>

     <div
      style={{
        marginLeft: "-28px",
        marginRight: "-28px",
        paddingLeft: "28px",
        paddingRight: "28px",
        paddingTop: "20px",
        paddingBottom: "20px",
        borderTop: "1px solid #eaeeed",
        display: "flex",
        alignItems: "center",
        gap: "40px",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "6px",  marginLeft: "25px"  }}>
        <span style={{ fontSize: "12px", fontWeight: "600", color: "#8FAAA3", letterSpacing: "1.5px", textTransform: "uppercase" }}>BEFORE</span>
        <span style={{ fontSize: "26px", fontWeight: "500", color: "#131B19", lineHeight: 1 }}>{numPrevShares}</span>
         <span style={{ fontSize: "16px", color: "#349F6F", fontWeight: "600" }}> {numPrevOwnership.toFixed(2)}% Ownership</span>   
      </div>

      <img src={ArrowCircle} alt="arrow" width="45" height="45" />

      <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
        <span style={{ fontSize: "12px", fontWeight: "600", color: "#8FAAA3", letterSpacing: "1.5px", textTransform: "uppercase" }}>NOW</span>
        <div style={{ display: "flex", alignItems: "baseline", gap: "10px" }}>
          <span style={{ fontSize: "26px", fontWeight: "500", color: "#131B19", lineHeight: 1 }}>{numCurrShares}</span>
          <span style={{
            background: numSharesDiff >= 0 ? "#E6F5EC" : "#FDECEC",
            color: numSharesDiff >= 0 ? "#349F6F" : "#ff0000",
            border: numSharesDiff >= 0 ? "1px solid #C2E6D1" : "1px solid #F5C2C2",
            borderRadius: "20px", padding: "2px 10px", fontSize: "13px", fontWeight: "600",
          }}> {numSharesDiff >= 0 ? "+" : ""}
              {numSharesDiff}</span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <span style={{ fontSize: "16px", color: numOwnerDiff < 0 ? "#ff0000" : "#349F6F", fontWeight: "600" }}> {numCurrOwnership.toFixed(2)}% Ownership</span>
          <span style={{
            background: numOwnerDiff >= 0 ? "#E6F5EC" : "#FDECEC",
            color: numOwnerDiff >= 0 ? "#349F6F" : "#ff0000",
            border: numOwnerDiff >= 0 ? "1px solid #C2E6D1" : "1px solid #F5C2C2",
            borderRadius: "20px", padding: "2px 8px", fontSize: "12px", fontWeight: "600",
          }}>{numOwnerDiff >= 0 ? " + " : ""}
             {numOwnerDiff.toFixed(2)}%</span>
        </div>
      </div>
    </div>
  </div>
  );
};



const AdditionalInfo = ({ formData, onChange, projectOptions, consolList }) => {
  const [otherFields, setOtherFields]           = useState([{ id: 1, fieldLabel: "", amount: "" }]);
  const [showConfigModal, setShowConfigModal]   = useState(false);
  const [showConsoleEntry, setShowConsoleEntry] = useState(() => {
    const hasData = [
      formData?.nciValue, formData?.consolInvestment,
      formData?.goodWill, formData?.otherInputs,
      formData?.netAssets, formData?.gainOnBargainPurchase
    ].some(v => Number(v) !== 0 && v !== undefined && v !== null);
    return hasData || false;
  });

  useEffect(() => {
    const hasData = [
      formData?.nciValue, formData?.consolInvestment,
      formData?.goodWill, formData?.otherInputs,
      formData?.netAssets, formData?.gainOnBargainPurchase
    ].some(v => Number(v) !== 0 && v !== undefined && v !== null);
    if (hasData) setShowConsoleEntry(true);
  }, [formData?.nciValue, formData?.consolInvestment, formData?.goodWill, formData?.otherInputs, formData?.netAssets, formData?.gainOnBargainPurchase]);
  const [selectedFsType, setSelectedFsType]     = useState("uploadPreset");

  const addField    = () => setOtherFields((p) => [...p, { id: Date.now(), fieldLabel: "", amount: "" }]);
  const removeField = (id) => setOtherFields((p) => p.filter((f) => f.id !== id));
  const updateField = (id, key, val) => {
    const updated = otherFields.map((f) => f.id === id ? { ...f, [key]: val } : f);
    setOtherFields(updated);

    onChange("addOtherDetails",updated
    .filter(f => f.fieldLabel || f.amount)
    .map(f => ({
        description: f.fieldLabel,
        amount: Number(f.amount) || 0,
      })));
    };

  return (
    <div style={{
      background: "#fff", border: "1px solid #EAEEED", borderRadius: "14px",
      padding: "24px 28px", display: "flex", flexDirection: "column", gap: "20px",
    }}>
     <div
      style={{
        marginLeft: "-28px",
        marginRight: "-28px",
        paddingLeft: "28px",
        paddingRight: "28px",
        paddingBottom: "16px",
        fontSize: "18px",
        fontWeight: "500",
        color: "#111",
        borderBottom: "1px solid #EAEEED",
      }}
    >
      Additional Info
    </div>

    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "15px", padding: "10px 0" }}>
      <div style={{ fontWeight: "500", whiteSpace: "nowrap" }}>
        Browse Control Date FS
      </div>
      <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
        <label
          style={{
            display: "flex",
            alignItems: "center",
            fontWeight: "500",
            cursor: "pointer",
          }}
        >
          <input
            type="radio"
            name="fsTypeSelection"
            value="uploadPreset"
            checked={selectedFsType === "uploadPreset"}
            onChange={(e) => {
              setSelectedFsType(e.target.value);
              onChange("FSType", "standalone");
              onChange("consolID", "");
            }}
            style={{ marginRight: "8px" }}
          />
          Upload Preset
        </label>

        <label
          style={{
            display: "flex",
            alignItems: "center",
            fontWeight: "500",
            cursor: "pointer",
          }}
        >
          <input
            type="radio"
            name="fsTypeSelection"
            value="existingConsol"
            checked={selectedFsType === "existingConsol"}
            onChange={(e) => {
              setSelectedFsType(e.target.value);
              onChange("FSType", "consol");
              onChange("controlDateFS", "");
            }}
            style={{ marginRight: "8px" }}
          />
          Select Existing Consol FS
        </label>
      </div>
    </div>

    {selectedFsType === "uploadPreset" && (
      <CustomDropdown
        label=""
        options={projectOptions}
        placeholder="Select Preset"
        value={formData?.controlDateFS}
        onChange={(v) => onChange("controlDateFS", v)}
        fullWidth
      />
    )}

    {selectedFsType === "existingConsol" && (
      <CustomDropdown
        label=""
        options={consolList || []}
        placeholder="Select Existing Consol FS"
        value={formData?.consolID}
        onChange={(v) => onChange("consolID", v)}
        fullWidth
      />
    )}

      <div style={{ border: "1px solid #EAEEED", borderRadius: "10px", padding: "16px" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "14px" }}>
          <span style={{ fontSize: "14px", fontWeight: "500", color: "#111" }}>Add Other Details</span>
          <button onClick={addField} style={{
            background: "none", border: "none", cursor: "pointer",
            display: "flex", alignItems: "center", gap: "6px",
            color: "#349F6F", fontSize: "16px", fontWeight: "500", padding: 0,
          }}>
            <PlusIcon width={15} height={15} /> Add Field
          </button>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {otherFields.map((f) => (
            <div key={f.id} style={{ display: "flex", gap: "10px", alignItems: "center" }}>
              <input
                className={investmentRegisterCss.input} style={{ flex: 2 }}
                placeholder="Type something..."
                value={f.fieldLabel}
                onChange={(e) => updateField(f.id, "fieldLabel", e.target.value)}
              />
              <div className={investmentRegisterCss.inputWrapper} style={{ flex: 1 }}>
                <input
                  className={investmentRegisterCss.input} style={{ paddingRight: "36px" }}
                  placeholder="Enter Amount"
                  value={f.amount}
                  onChange={(e) => updateField(f.id, "amount", e.target.value)}
                />
                <span className={investmentRegisterCss.iconRight}>
                  <img src={rupeeIcon} alt="₹" className={investmentRegisterCss.rupeeIcon} />
                </span>
              </div>
              <button onClick={() => removeField(f.id)} style={{
                background: "none", border: "none", cursor: "pointer",
                padding: "4px", display: "flex", alignItems: "center",
              }}>
                <RemoveIcon />
              </button>
            </div>
          ))}
        </div>
      </div>


      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontSize: "14px", color: "#111" }}>
        <span>Is the transaction covered as common control transaction?</span>
        <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
          {["NO", "YES"].map((opt) => (
            <label key={opt} style={{ display: "flex", alignItems: "center", gap: "6px", cursor: "pointer" }}>
              <input
                type="radio" name="commonControl" value={opt}
                checked={(formData?.isCommonControl || "NO") === opt}
                onChange={() => onChange("isCommonControl", opt)}
                style={{ accentColor: "#3AB67D", cursor: "pointer", width: "16px", height: "16px" }}
              />
              {opt}
            </label>
          ))}
        </div>
      </div>

      <div>
        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <button
            type="button"
            onClick={() => setShowConsoleEntry((p) => !p)}
            style={{
              background: "#fff", border: "1px solid #EAEEED", borderRadius: "8px",
              padding: "10px 20px", cursor: "pointer", fontSize: "14px", fontWeight: "500", color: "#111",
            }}
          >
            Create Consol Entry
          </button>
          <button
            type="button"
            onClick={() => setShowConfigModal(true)}
            style={{
              background: "#205a46", border: "1px solid #205a46", borderRadius: "8px",
              padding: "10px 20px", cursor: "pointer", fontSize: "14px", fontWeight: "500", color: "#ffffff",
            }}
          >
            Configure mapping
          </button>
        </div>

        {showConsoleEntry && (
          <div style={{ display: "flex", gap: "20px", marginTop: "12px" }}>
            <motion.div
              initial={{ opacity: 0, y: -8 }} animate={{ opacity: 1, y: 0 }}
              style={{ flex: 1, border: "1px solid #EAEEED", borderRadius: "10px", overflow: "hidden" }}
            >
              <div style={{ padding: "12px 16px", fontSize: "13px", fontWeight: "600", color: "#4D6D64", borderBottom: "1px solid #EAEEED" }}>
                Consol Entry
              </div>
              {[
                { label: "Non-Controlling Asset", value: formData.nciValue || 0 },
                { label: "Investments", value: formData.consolInvestment || 0 },
                { label: "Goodwill", value: formData.goodWill || 0 },
                { label: "Other inputs", value: formData.otherInputs || 0 },
                { label: "Net Assets", value: formData.netAssets || 0 },
                { label: "Gain on bargain purchase", value: formData.gainOnBargainPurchase || 0 }
              ].map((row, i) => (
                <div key={i} style={{
                  display: "flex", justifyContent: "space-between", padding: "12px 16px",
                  fontSize: "14px", color: "#111",
                }}>
                  <span>{row.label}</span>
                  <span style={{ fontWeight: "400" }}>{formatIndianNumber(row.value) || 0}</span>
                </div>
              ))}
            </motion.div>

            {formData.investmentCurrency && (
              <motion.div
                initial={{ opacity: 0, y: -8 }} animate={{ opacity: 1, y: 0 }}
                style={{ flex: 1, border: "1px solid #EAEEED", borderRadius: "10px", overflow: "hidden" }}
              >
                <div style={{ padding: "12px 16px", fontSize: "13px", fontWeight: "600", color: "#4D6D64", borderBottom: "1px solid #EAEEED" }}>
                  Consol Entry in Subsidiary's Local Currency
                </div>
                {[
                  { label: "Non-Controlling Asset", value: formData.nciValue || 0 },
                  { label: "Investments", value: formData.consolInvestment || 0 },
                  { label: "Goodwill", value: formData.goodWill || 0 },
                  { label: "Other inputs", value: formData.otherInputs || 0 },
                  { label: "Net Assets", value: formData.netAssets || 0 },
                  { label: "Gain on bargain purchase", value: formData.gainOnBargainPurchase || 0 }
                ].map((row, i) => (
                  <div key={i} style={{
                    display: "flex", justifyContent: "space-between", padding: "12px 16px",
                    fontSize: "14px", color: "#111",
                  }}>
                    <span>{row.label}</span>
                    <span style={{ fontWeight: "400" }}>{formatIndianNumber(row.value) || 0}</span>
                  </div>
                ))}
              </motion.div>
            )}
          </div>
        )}
      </div>

      <ConsolEntryConfigModal
        isOpen={showConfigModal}
        onClose={() => setShowConfigModal(false)}
        fsType={formData.FSType || "standalone"}
        fsId={formData.controlDateFS || ""}
        consolID={formData.consolID}
        mappingValue={formData.autoAdjustmentMapping || []}
        onSave={(mapping) => {
          onChange("autoAdjustmentMapping", mapping);
        }}
      />
    </div>
  );
};


const CreateInvestment1 = ({ registerID, onBack, initialInvestorCompany, initialInvesteeCompany }) => {
const history = useHistory();
const location = useLocation();
const pathArray = location.pathname.split("/");
const workspace_id = pathArray[2];

console.log("URL path:", location.pathname);
console.log("Workspace ID from URL:", workspace_id);

const [formData, setFormData] = useState({});
const [selectedTransaction, setSelectedTransaction] = useState("Purchase of Shares");
const [projectOptions, setProjectOptions] = useState([]);
const [consolList, setConsolList] = useState([]);
const [isLoading, setIsLoading] = useState(false);
const user_id = localStorage.getItem("user_id");
const [companyOptions, setCompanyOptions] = useState([]);
const [loadingCompanies, setLoadingCompanies] = useState(true);
const [selectedFile, setSelectedFile] = useState(null);
const [previousShares, setPreviousShares] = useState(0);
const [currentShares, setCurrentShares] = useState(0);
const [registerName, setRegisterName] = useState("");

useEffect(() => {
    console.log("useEffect - Attempting to fetch consol list");
    console.log("Workspace ID available:", workspace_id);
    
    if (!workspace_id) {
        console.warn("No workspace_id available from URL");
        return;
    }
    
    getAllConsolApi(workspace_id)
        .then(res => {
            console.log("getAllConsol API Response:", res.data);
            const consols = res.data?.consolList || []; 
            console.log("Consols array:", consols);

            const consolOptions = consols.map(c => ({
                value: c._id,
                label: c.name,
            }));
            console.log("Formatted consolOptions:", consolOptions);

            setConsolList(consolOptions);
        })
        .catch(err => console.error("Failed to fetch consol list:", err));
}, [workspace_id]);

const [previousOwnership, setPreviousOwnership] = useState(0);
const [currentOwnership, setCurrentOwnership] = useState(0);
const [successPopup, setSuccessPopup] = useState({ isOpen: false, message: "" });
const [errorPopup, setErrorPopup] = useState({ isOpen: false, message: "" });

const handleSuccessClose = () => {
  setSuccessPopup({ isOpen: false, message: "" });
  if (onBack) onBack();
};

const getRelationshipStatus = (percentage) => {
  const value = Number(percentage);

  if (value <= 20) return "Investment";
  if (value > 20 && value < 50) return "Associate";
  if (value === 50) return "Joint Venture";
  if (value > 50) return "Subsidiary";

  return "Investment";
};
  const ownershipDifference = currentOwnership - previousOwnership;
  const sharesDifference = currentShares - previousShares;
  const set = (field) => (val) => setFormData((p) => {
    const newData = { ...p, [field]: val };
    if (field === "investorCompany") {
      const selectedCompany = companyOptions.find(c => c.value === val);
      if (selectedCompany && selectedCompany.functional) {
        newData.investmentCurrency = selectedCompany.functional;
      } else {
        newData.investmentCurrency = "";
      }
    }
    return newData;
  });
  const f   = (field) => formData[field] || "";
  const relationship = f("natureOfRelationship") || getRelationshipStatus(currentOwnership);
  const handleTransactionChange = (val) => { 
    setSelectedTransaction(val); 
  };

  const handleCreate = async () => {
    if (!f("investorCompany") || !f("investeeCompany")) {
      setErrorPopup({ isOpen: true, message: "Please select both Investor and Investee company." });
      return;
    }

    try {
      setIsLoading(true);

      const isSale = selectedTransaction === "Sale of Shares to Third Party";

      const payload = { 
        natureOfTransaction:        selectedTransaction,
        investorCompanyID:          f("investorCompany"),
        investeeCompanyID:          f("investeeCompany"),
        natureOfRelationship:       f("natureOfRelationship") || relationship,
        transactionDate:            f("transactionDate") || "",
        notesRemarks:               f("notes") || "",
        isCommonControlTransaction: f("isCommonControl") === "YES",
        addOtherDetails:            f("addOtherDetails") || [],
        investmentCurrency:         f("investmentCurrency") || "USD",

        browseControlDateFSType:    formData.FSType || "standalone",
        ...(formData.FSType === "standalone" && { browseControlDateFS: f("controlDateFS") || "" }),
        ...(formData.FSType === "consol" && { browseControlDateConsolID: formData.consolID || null }),

        autoAdjustmentMapping:     formData.autoAdjustmentMapping || [],

        consolEntry: {
          nonControllingAsset: Number(f("nciValue")) || 0,
          investment: Number(f("consolInvestment")) || 0,
          goodWill: Number(f("goodWill")) || 0,
          otherInputs: Number(f("otherInputs")) || 0,
          netAssets: Number(f("netAssets")) || 0,
          gainOnBargainPurchase: Number(f("gainOnBargainPurchase")) || 0
        },

        ...(!isSale && {
          classOfShare:               f("classOfShare") || "",
          noOfSharesPurchased:        Number(f("noOfShares")) || 0,
          purchasePricePerShare:      Number(f("purchasePricePerShare")) || 0,
          totalConsideration:         Number(f("totalConsideration")) || 0,
          totalSharesOutstanding:     Number(f("totalSharesOutstanding")) || 0,
          purchasedFrom:              f("purchasedFrom") || "",
          costBasisMethod:            f("costBasisMethod") || "",
          cashBankPaidUpfront:        Number(f("cashBankPaid")) || 0,
          deferredConsideration:      Number(f("deferredConsideration")) || 0,
          deferredPaymentDate:        f("deferredPaymentDate") || null,
          contingentPaymentDate:      f("contingentPaymentDate") || null,
          contingentConsiderationFV:  Number(f("contingentConsideration")) || 0,
          contingencyDescription:     f("contingencyDescription") || "",
          maxContingentAmount:        Number(f("maxContingentAmount")) || 0,
          transactionCosts:           Number(f("transactionCosts")) || 0,
        }),

        ...(isSale && {
          noOfSharesSold:      Number(f("noOfSharesSold")) || 0,
          salePricePerShare:   Number(f("salePricePerShare")) || 0,
          totalSaleProceeds:   Number(f("totalSaleProceeds")) || 0,
          costBasisMethod:     f("costBasisMethod") || "",
          costOfSharesSold:    Number(f("costOfSharesSold")) || 0,
          gainOrLossInSale:    Number(f("gainOrLossInSale") || f("gainOrLoss")) || 0,
          soldTo:              f("soldTo") || "",
        }),

        ...(selectedTransaction === "Buyback by Investee from Investor" && {
          noOfSharesBoughtBack: Number(f("noOfSharesBoughtBack")) || 0,
          buybackPricePerShare: Number(f("buybackPricePerShare")) || 0,
          totalBuybackProceeds: Number(f("totalBuybackProceeds")) || 0,
          costBasisMethod: f("costBasisMethod") || "",
          costOfSharesBoughtBack: Number(f("costOfSharesBoughtBack")) || 0,
          gainOrLoss: Number(f("gainOrLoss")) || 0,
          buybackReference: f("buybackReference") || "",
        }),

        ...(selectedTransaction === "Subscription to Rights Issue" && {
          rightsRatio: f("rightsRatio") || "",
          rightsEntitlement: f("rightsEntitlement") || "",
          rightsExercised: f("rightsExercised") || "",
          rightsRenounced: f("rightsRenounced") || "",
          rightsIssuePrice: Number(f("rightsIssuePrice")) || 0,
          amountPaid: Number(f("amountPaid")) || 0,
          totalSharesIssuedInRights: f("totalSharesIssuedInRights") || "",
        }),

        ...(selectedTransaction === "Stock Split by Investee" && {
          splitRatio: f("splitRatio") || "",
          oldFaceValue: Number(f("oldFaceValue")) || 0,
          newFaceValue: Number(f("newFaceValue")) || 0,
        }),

        ...(selectedTransaction === "Bonus Issue by Investee" && {
          bonusRatio: f("bonusRatio") || "",
          bonusSharesReceived: Number(f("bonusSharesReceived")) || 0,
          faceValuePerShare: Number(f("faceValuePerShare")) || 0,
          totalSharesAfterBonus: f("totalSharesAfterBonus") || "",
          recordDate: f("recordDate") || null,
        }),
      };

      const res = await createInvestmentTransaction(registerID, payload);

      if (res.data?.success || res.status === 200 || res.status === 201) {
        setSuccessPopup({ isOpen: true, message: res.data?.message || "Investment created successfully" });
      }
    } catch (error) {
      setErrorPopup({
        isOpen: true,
        message: error?.response?.data?.error || error?.response?.data?.message || "Something went wrong",
      });
    } finally {
      setIsLoading(false);
    }
  };

useEffect(() => {
  setFormData(prev => ({
    ...prev,
    natureOfRelationship: getRelationshipStatus(currentOwnership)
  }));
}, [currentOwnership]);

  // useEffect(() => {
  //   const purchasedShares = Number(formData.noOfShares || 0);
  //   const totalShares = Number(formData.totalSharesOutstanding || 0);

  //   setCurrentShares(purchasedShares);

  //   const percent = totalShares ? (purchasedShares / totalShares) * 100 : 0;

  //   setCurrentOwnership(percent);
  // }, [formData.noOfShares, formData.totalSharesOutstanding]);

useEffect(() => {
  const purchase = Number(formData.noOfShares || 0);
  const sale = Number(formData.noOfSharesSold || 0);

  let nowShares = previousShares;

  if (selectedTransaction === "Purchase of Shares") {
    nowShares += purchase;
  }

  if (selectedTransaction === "Sale of Shares to Third Party") {
    nowShares -= sale;
  }

  if (nowShares < 0) nowShares = 0;

  setCurrentShares(nowShares);

  const totalOutstanding =
    Number(formData.totalSharesOutstanding) ||
    (previousOwnership > 0
      ? (previousShares / previousOwnership) * 100
      : 0);

  const percent =
    totalOutstanding > 0 ? (nowShares / totalOutstanding) * 100 : 0;

  setCurrentOwnership(percent);

}, [
  formData.noOfShares,
  formData.noOfSharesSold,
  formData.totalSharesOutstanding,
  selectedTransaction,
  previousShares,
  previousOwnership
]);

 useEffect(() => {
  if (!user_id) return;
  GetProjectsBasedOnUserId(user_id)
    .then(res => {
      const projects = res.data.result || [];
      const options = projects.map(p => ({
        value: p._id,
        label: p.project_name,
      }));
      setProjectOptions(options);
    })
    .catch(err => console.error("Failed to fetch projects:", err));
}, []);

// useEffect(() => {
//   if (!registerID) return;

//   getInvestmentSummary(registerID)
//     .then((res) => {
//       const summary = res.data?.summary || [];

//       let totalShares = 0;
//       let totalPercent = 0;

//       summary.forEach((item) => {
//         const latest = item.latestTransaction || {};

//         const shares = Number(latest.noOfSharesPurchased || 0);
//         const totalOutstanding = Number(latest.totalSharesOutstanding || 0);

//         totalShares += shares;

//         if (totalOutstanding) {
//           totalPercent += (shares / totalOutstanding) * 100;
//         }
//       });

//       setPreviousShares(totalShares);
//       setPreviousOwnership(totalPercent);
//     })
//     .catch((err) => console.error(err));
// }, [registerID]);

useEffect(() => {
  if (!registerID || !formData.investorCompany) {
    setPreviousShares(0);
    setPreviousOwnership(0);
    return;
  }

  getInvestmentRegisterForms(registerID)
    .then((res) => {
      const investments = res.data?.investmentRegister?.investments || [];

      const filtered = investments.filter(
        (t) => t.investorCompanyID === formData.investorCompany
      );

      if (!filtered.length) {
        setPreviousShares(0);
        setPreviousOwnership(0);
        return;
      }

      const sorted = filtered.sort(
        (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
      );

      let totalShares = 0;
      let totalOutstanding = 0;

      sorted.forEach((item) => {
        const purchased = Number(item.noOfSharesPurchased) || 0;
        const sold = Number(item.noOfSharesSold) || 0;

        if (item.natureOfTransaction?.toLowerCase().includes("sale")) {
          totalShares -= sold;
        } else {
          totalShares += purchased;
        }

        if (item.totalSharesOutstanding) {
          totalOutstanding = Number(item.totalSharesOutstanding);
        }
      });

      setPreviousShares(totalShares);

      setPreviousOwnership(
        totalOutstanding ? (totalShares / totalOutstanding) * 100 : 0
      );
    })
    .catch(console.error);
}, [registerID, formData.investorCompany]);

useEffect(() => {
  console.log("registerID:", registerID); 
  if (!registerID) return;

  setLoadingCompanies(true);

  if (registerID) {
    getInvestmentRegisterForms(registerID)
      .then(res => setRegisterName(res.data?.investmentRegister?.name || "Investment Name"))
      .catch(err => console.error("Failed to fetch register name:", err));
  }
  Promise.all([
    getLinkedCompanies(registerID),
    GetAllCompanyData()
  ])
    .then(([linkedRes, allDataRes]) => {
      const companies = linkedRes.data?.companies || linkedRes.data?.result || linkedRes.data?.data || [];
      const allCompanyData = allDataRes.data?.getAllCompanyData || [];

      setCompanyOptions(
        companies.map(c => {
          const fullData = allCompanyData.find(ac => ac._id === c._id);
          return {
            value: c._id,
            label: c.company_name,
            functional: fullData ? fullData.functional : c.functional,
          };
        })
      );
    })
    .catch(err => console.error("Company fetch error:", err))
    .finally(() => setLoadingCompanies(false));
}, [registerID]);

useEffect(() => {
  if (!initialInvestorCompany || !initialInvesteeCompany) return;

  const investorId = typeof initialInvestorCompany === "object"
    ? initialInvestorCompany._id || initialInvestorCompany.value
    : initialInvestorCompany;
  const investeeId = typeof initialInvesteeCompany === "object"
    ? initialInvesteeCompany._id || initialInvesteeCompany.value
    : initialInvesteeCompany;
  if (!investorId || !investeeId) return;

  const investor = companyOptions.find((company) => company.value === investorId);
  setFormData((previous) => ({
    ...previous,
    investorCompany: previous.investorCompany || investorId,
    investeeCompany: previous.investeeCompany || investeeId,
    investmentCurrency: previous.investmentCurrency || investor?.functional || "",
  }));
}, [initialInvestorCompany, initialInvesteeCompany, companyOptions]);

  const isSale = selectedTransaction === "Sale of Shares to Third Party";

  const renderTransactionFields = () => {
    switch (selectedTransaction) {

      case "Purchase of Shares":
        return (
          <>
            <Row>
              <CustomDropdown
                label="Investee Company"
                options={companyOptions}
                value={f("investeeCompany")}
                onChange={set("investeeCompany")}
                placeholder={loadingCompanies ? "Loading..." : "Select Investee Company"}
              />
              <CustomDropdown
                label="Investor Company"
                options={companyOptions}
                value={f("investorCompany")}
                onChange={set("investorCompany")}
                placeholder={loadingCompanies ? "Loading..." : "Select Investor Company"}
              />
              <DateInput label="Transaction Date" value={f("transactionDate")} onChange={set("transactionDate")} />
              
              <TextInput      label="No Of Shares Purchased"   placeholder="Enter No Of Shares"  value={f("noOfShares")}            onChange={set("noOfShares")} />
              <CustomDropdown label="Class Of Share"           options={CLASS_OF_SHARE_OPTIONS}  value={f("classOfShare")}          onChange={set("classOfShare")}          placeholder="Select class of share" />
              <AmountInput    label="Purchase Price Per Share"                                    value={f("purchasePricePerShare")} onChange={set("purchasePricePerShare")} />
              
              <TextInput      label="Investment Currency"      placeholder="Type Currency (e.g. USD)" value={f("investmentCurrency")}  onChange={set("investmentCurrency")} readOnly={true} />
              <AmountInput label="Total Consideration"                                           value={f("totalConsideration")}     onChange={set("totalConsideration")} />
              <TextInput   label="Total Shares Outstanding"    placeholder="Enter No. of Shares" value={f("totalSharesOutstanding")} onChange={set("totalSharesOutstanding")} />
              
              <TextInput   label="Purchased From"              placeholder="Select company or type seller name" value={f("purchasedFrom")} onChange={set("purchasedFrom")} />
              <CustomDropdown label="Cost Basis Method"        options={COST_BASIS_OPTIONS}      value={f("costBasisMethod")}        onChange={set("costBasisMethod")}      placeholder="Select method" />
              <AmountInput    label="Cash/Bank Paid (Upfront)"                                   value={f("cashBankPaid")}           onChange={set("cashBankPaid")} />
              
              <AmountInput    label="Deferred Consideration"                                     value={f("deferredConsideration")}  onChange={set("deferredConsideration")} />
              <DateInput   label="Deferred Payment Date"                                         value={f("deferredPaymentDate")}     onChange={set("deferredPaymentDate")} />
              <AmountInput label="Contingent Consideration (FV)"                                 value={f("contingentConsideration")} onChange={set("contingentConsideration")} />
              
              <TextInput   label="Contingency Description"     placeholder="Type something..."   value={f("contingencyDescription")}  onChange={set("contingencyDescription")} />
              <AmountInput label="Max Contingent Amount"                                         value={f("maxContingentAmount")}    onChange={set("maxContingentAmount")} />
              <DateInput   label="Contingent Payment Date"                                       value={f("contingentPaymentDate")}  onChange={set("contingentPaymentDate")} placement="top" />
              
              <AmountInput label="Transaction Costs"                                             value={f("transactionCosts")}       onChange={set("transactionCosts")} />
            </Row>

            <CustomDropdown
              label="Nature Of Relationship"
              options={RELATIONSHIP_OPTIONS}
              value={relationship}
              onChange={set("natureOfRelationship")}
              placeholder="Associate"
              fullWidth
            />
          </>
        );

      case "Sale of Shares to Third Party":
        return (
          <>
            <Row>
              <DateInput label="Transaction Date" value={f("transactionDate")} onChange={set("transactionDate")} />
              <CustomDropdown
                label="Investor Company"
                options={companyOptions}
                value={f("investorCompany")}
                onChange={set("investorCompany")}
                placeholder={loadingCompanies ? "Loading..." : "Select Investor Company"}
              />
              <CustomDropdown
                label="Investee Company"
                options={companyOptions}
                value={f("investeeCompany")}
                onChange={set("investeeCompany")}
                placeholder={loadingCompanies ? "Loading..." : "Select Investee Company"}
              />
            </Row>

            <Row>
              <TextInput   label="No Of Shares Sold"        placeholder="Enter No Of Shares"   value={f("noOfSharesSold")}       onChange={set("noOfSharesSold")} />
              <AmountInput label="Sale Price Per Share"                                         value={f("salePricePerShare")}    onChange={set("salePricePerShare")} />
              <AmountInput label="Total Sale Proceeds"                                          value={f("totalSaleProceeds")}   onChange={set("totalSaleProceeds")} />
            </Row>

            <Row>
              <CustomDropdown label="Cost Basis Method"  options={COST_BASIS_OPTIONS}          value={f("costBasisMethod")}      onChange={set("costBasisMethod")} placeholder="Select method" />
              <AmountInput    label="Cost Of Shares Sold"                                       value={f("costOfSharesSold")}    onChange={set("costOfSharesSold")} />
              <AmountInput    label="Gain Or Loss In Sale"                                      value={f("gainOrLossInSale")}    onChange={set("gainOrLossInSale")} />
            </Row>

            <Row2>
              <TextInput label="Sold To" placeholder="Select company or type buyer name"        value={f("soldTo")}              onChange={set("soldTo")} />
              <CustomDropdown
                label="Nature Of Relationship"
                options={RELATIONSHIP_OPTIONS}
                value={relationship}
                onChange={set("natureOfRelationship")}
                placeholder="Associate"
              />
            </Row2>
          </>
        );

      case "Buyback by Investee from Investor":
        return (
          <>
            <Row>
              <DateInput label="Transaction Date" value={f("transactionDate")} onChange={set("transactionDate")} />
              <CustomDropdown
                label="Investor Company"
                options={companyOptions}
                value={f("investorCompany")}
                onChange={set("investorCompany")}
                placeholder={loadingCompanies ? "Loading..." : "Select Investor Company"}
              />
              <CustomDropdown
                label="Investee Company"
                options={companyOptions}
                value={f("investeeCompany")}
                onChange={set("investeeCompany")}
                placeholder={loadingCompanies ? "Loading..." : "Select Investee Company"}
              />
            </Row>

            <Row>
              <TextInput   label="No Of Shares Bought Back" placeholder="Enter No Of Shares"      value={f("noOfSharesBoughtBack")}    onChange={set("noOfSharesBoughtBack")} />
              <AmountInput label="Buyback Price Per Share"                                          value={f("buybackPricePerShare")}   onChange={set("buybackPricePerShare")} />
              <AmountInput label="Total Buyback Proceeds"                                           value={f("totalBuybackProceeds")}  onChange={set("totalBuybackProceeds")} />
            </Row>

            <Row>
              <CustomDropdown label="Cost Basis Method"    options={COST_BASIS_OPTIONS}            value={f("costBasisMethod")}         onChange={set("costBasisMethod")} placeholder="Select method" />
              <AmountInput    label="Cost Of Shares Bought Back"                                   value={f("costOfSharesBoughtBack")} onChange={set("costOfSharesBoughtBack")} />
              <AmountInput    label="Gain Or Loss"                                                 value={f("gainOrLoss")}             onChange={set("gainOrLoss")} />
            </Row>

            <Row2>
              <TextInput label="Buyback Reference / Board Resolution" placeholder="Type something..." value={f("buybackReference")}   onChange={set("buybackReference")} />
              <CustomDropdown
                label="Nature Of Relationship"
                options={RELATIONSHIP_OPTIONS}
                value={relationship}
                onChange={set("natureOfRelationship")}
                placeholder="Associate"
              />
            </Row2>
          </>
        );

      case "Subscription to Rights Issue":
        return (
          <>
            <Row>
              <DateInput label="Transaction Date" value={f("transactionDate")} onChange={set("transactionDate")} />
              <CustomDropdown
                label="Investor Company"
                options={companyOptions}
                value={f("investorCompany")}
                onChange={set("investorCompany")}
                placeholder={loadingCompanies ? "Loading..." : "Select Investor Company"}
              />
              <CustomDropdown
                label="Investee Company"
                options={companyOptions}
                value={f("investeeCompany")}
                onChange={set("investeeCompany")}
                placeholder={loadingCompanies ? "Loading..." : "Select Investee Company"}
              />
            </Row>

            <Row>
              <TextInput   label="Rights Ratio"              placeholder="Enter ratio"                value={f("rightsRatio")}               onChange={set("rightsRatio")} />
              <TextInput   label="Rights Entitlement"        placeholder="Enter rights entitlement"   value={f("rightsEntitlement")}         onChange={set("rightsEntitlement")} />
              <TextInput   label="Rights Exercised"          placeholder="Enter rights exercised"     value={f("rightsExercised")}           onChange={set("rightsExercised")} />
            </Row>

            <Row>
              <TextInput   label="Rights Renounced"          placeholder="Enter renounced rights"     value={f("rightsRenounced")}           onChange={set("rightsRenounced")} />
              <AmountInput label="Rights Issue Price"                                                  value={f("rightsIssuePrice")}          onChange={set("rightsIssuePrice")} />
              <AmountInput label="Amount Paid"                                                         value={f("amountPaid")}                onChange={set("amountPaid")} />
            </Row>

            <Row2>
              <TextInput label="Total Shares Issued In Rights (All Shareholders)" placeholder="Enter No Of Shares" value={f("totalSharesIssuedInRights")} onChange={set("totalSharesIssuedInRights")} />
              <CustomDropdown
                label="Nature Of Relationship"
                options={RELATIONSHIP_OPTIONS}
                value={relationship}
                onChange={set("natureOfRelationship")}
                placeholder="Associate"
              />
            </Row2>
          </>
        );

      case "Stock Split by Investee":
        return (
          <>
            <Row>
              <DateInput label="Transaction Date" value={f("transactionDate")} onChange={set("transactionDate")} />
              <CustomDropdown
                label="Investor Company"
                options={companyOptions}
                value={f("investorCompany")}
                onChange={set("investorCompany")}
                placeholder={loadingCompanies ? "Loading..." : "Select Investor Company"}
              />
              <CustomDropdown
                label="Investee Company"
                options={companyOptions}
                value={f("investeeCompany")}
                onChange={set("investeeCompany")}
                placeholder={loadingCompanies ? "Loading..." : "Select Investee Company"}
              />
            </Row>

            <Row>
              <TextInput   label="Split Ratio"       placeholder="Enter ratio"      value={f("splitRatio")}       onChange={set("splitRatio")} />
              <AmountInput label="Old Face Value"                                    value={f("oldFaceValue")}     onChange={set("oldFaceValue")} />
              <AmountInput label="New Face Value"                                    value={f("newFaceValue")}     onChange={set("newFaceValue")} />
            </Row>

            <CustomDropdown
              label="Nature Of Relationship"
              options={RELATIONSHIP_OPTIONS}
              value={relationship}
              onChange={set("natureOfRelationship")}
              placeholder="Associate"
              fullWidth
            />
          </>
        );

      case "Bonus Issue by Investee":
        return (
          <>
            <Row>
              <DateInput label="Transaction Date" value={f("transactionDate")} onChange={set("transactionDate")} />
              <CustomDropdown
                label="Investor Company"
                options={companyOptions}
                value={f("investorCompany")}
                onChange={set("investorCompany")}
                placeholder={loadingCompanies ? "Loading..." : "Select Investor Company"}
              />
              <CustomDropdown
                label="Investee Company"
                options={companyOptions}
                value={f("investeeCompany")}
                onChange={set("investeeCompany")}
                placeholder={loadingCompanies ? "Loading..." : "Select Investee Company"}
              />
            </Row>

            <Row>
              <TextInput   label="Bonus Ratio"                  placeholder="Enter ratio e.g. 1:2"  value={f("bonusRatio")}          onChange={set("bonusRatio")} />
              <TextInput   label="No Of Bonus Shares Received"  placeholder="Enter No Of Shares"    value={f("bonusSharesReceived")} onChange={set("bonusSharesReceived")} />
              <AmountInput label="Face Value Per Share"                                               value={f("faceValuePerShare")}  onChange={set("faceValuePerShare")} />
            </Row>

            <Row>
              <TextInput   label="Total Shares After Bonus"  placeholder="Enter No. of Shares"   value={f("totalSharesAfterBonus")} onChange={set("totalSharesAfterBonus")} />
              <DateInput   label="Record Date"                                                     value={f("recordDate")}            onChange={set("recordDate")} />
              <CustomDropdown
                label="Nature Of Relationship"
                options={RELATIONSHIP_OPTIONS}
                value={relationship}
                onChange={set("natureOfRelationship")}
                placeholder="Associate"
              />
            </Row>
          </>
        );

      default:
        return null;
    }
  };

  return (
    <div className={commoncss.pageLayout}>
      <Sidebar />
      <div className={`d-flex ${commoncss.pageContent}`}>
        <IRMenu activeTab={"Investments"} registerID={registerID} />

        <motion.div
          initial={{ x: 60, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: 60, opacity: 0 }}
          transition={{ duration: 0.35, ease: "easeInOut" }}
          className={investmentRegisterCss.irLayout}
        >

          <div className={investmentRegisterCss.iDHeader}>
            <div style={{ display: "flex", alignItems: "center", gap: "10px", fontSize: "14px" }}>
              <span style={{ cursor: "pointer", display: "flex", alignItems: "center" }} onClick={onBack}>
                <LeftArrowIcon height={12} style={{ marginBottom: "2px", marginRight: "6px" }} />
              </span>
              <span style={{ color: "#4D6D64", fontWeight: "500", cursor: "pointer" }} onClick={() => history.push(`/detailsIR/${workspace_id || registerID}`)}>Investments</span>
              <span style={{ display: "flex", alignItems: "center", margin: "0 4px" }}>
                <DotIcon />
              </span>
              <span style={{ color: "#4D6D64", fontWeight: "500", cursor: "pointer" }} onClick={onBack}>Investment Timeline</span>
              <span style={{ display: "flex", alignItems: "center", margin: "0 4px" }}>
                <DotIcon />
              </span>
              <span style={{ color: "#111", fontWeight: "600" }}>Add Transaction</span>
            </div>
            <Button btnColor={buttoncss.primary} label={isLoading ? "Creating..." : "Create"}
           onClick={handleCreate} disabled={isLoading}/>
          </div>

     
          <div className={investmentRegisterCss.iDContainer}>

            <Section>
        
              <CustomDropdown
                label="Nature Of Transaction"
                options={NATURE_OPTIONS}
                value={selectedTransaction}
                onChange={handleTransactionChange}
                placeholder="Select transaction type"
                fullWidth
              />

              {renderTransactionFields()}

              {(selectedTransaction === "Purchase of Shares" || isSale) && (
                <div>
                  <label className={investmentRegisterCss.label} style={{ display: "block", marginBottom: 8 }}>
                    Attach Valuation Report
                  </label>

                  <div
                    className={investmentRegisterCss.dragBox}
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={(e) => {
                      e.preventDefault();
                      const file = e.dataTransfer.files[0];
                      if (file) setSelectedFile(file);
                    }}
                    onClick={() => document.getElementById("ci1FileInput")?.click()}
                  >
                    <div>
                      Drag and drop your file here
                    </div>

                    <input
                      id="ci1FileInput"
                      type="file"
                      accept=".pdf,.txt,.csv,.xls,.xlsx,.doc,.docx"
                      style={{ display: "none" }}
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (file) setSelectedFile(file);
                      }}
                    />
                  </div>

                  {selectedFile && (
                    <div
                      style={{ marginTop: "12px", border: "1px solid #EAEEED", borderRadius: "8px", padding: "10px 14px", display: "flex", alignItems: "center", justifyContent: "space-between", background: "#fff" }} >
                      <span style={{ fontSize: "14px", color: "#205a46",  fontWeight: "500", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: "80%" }} >
                        {selectedFile.name}
                      </span>

                      <button
                        onClick={() => setSelectedFile(null)}
                        style={{ background: "none", border: "none",  cursor: "pointer", color: "#8FAAA3", fontSize: "16px" }}  >
                        ✕
                      </button>
                    </div>
                  )}
                </div>
              )}

              <div>
                <label className={investmentRegisterCss.label} style={{ display: "block", marginBottom: 6 }}>Notes / Remarks</label>
                <textarea
                  className={investmentRegisterCss.input}
                  placeholder="Placeholder text"
                  value={f("notes")}
                  onChange={(e) => set("notes")(e.target.value)}
                  rows={4}
                  style={{ paddingTop: "10px", minHeight: "80px" }}
                />
              </div>
            </Section>

      
            <HoldingStatus 
              previousShares={previousShares}
              currentShares={currentShares}
              previousOwnership={previousOwnership}
              currentOwnership={currentOwnership} 
              ownershipDifference={ownershipDifference}
              sharesDifference={sharesDifference}
              relationship={relationship} 
            />

            {(selectedTransaction === "Purchase of Shares" || isSale) && (
              <AdditionalInfo formData={formData} projectOptions={projectOptions} consolList={consolList}
              onChange={(field, val) => setFormData((p) => ({ ...p, [field]: val }))} />
            )}

          </div>
        </motion.div>
      </div>

      <SuccessPopup
        isOpen={successPopup.isOpen}
        message={successPopup.message}
        onClose={handleSuccessClose}
      />
      <ErrorPopup
        isOpen={errorPopup.isOpen}
        message={errorPopup.message}
        onClose={() => setErrorPopup({ isOpen: false, message: "" })}
      />
    </div>
  );
};

export default CreateInvestment1;